import React from "react";
import { Backdrop, CircularProgress, Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import logo from "bb-logo-blue-name.png";

const useStyles = makeStyles((theme) => ({
  backdrop: {
    color: theme.palette.secondary.main,
    background: theme.palette.secondary.light,
  },
  logo: {
    width: 200,
  },
}));

const LoadingIndicator = () => {
  const classes = useStyles();
  return (
    <Backdrop className={classes.backdrop} open={true}>
      <Grid
        container
        spacing={1}
        direction="column"
        alignContent="center"
        alignItems="center"
      >
        <Grid item>
          <img
            className={classes.logo}
            src={logo}
            alt="Loading BiblioBoard reporting..."
          />
        </Grid>
        <Grid item>
          <CircularProgress color="inherit" />
        </Grid>
      </Grid>
    </Backdrop>
  );
};

export default LoadingIndicator;
